import { Subject } from "rxjs";

const AppState = new Subject();

export default AppState;